module.exports = __webpack_public_path__ + "media/bootstrap-icons/zoom-out-8d13427f.svg";